import gql from 'graphql-tag';

import { TitleFragment } from '@graphqlTypes';
import { Container, HeadlineAnim, RevealWrapper } from '@components';
import { getHighlightMarkup } from '@/core/utils';
import { useRef } from "react";

import { useViewSize } from '@/providers/ViewSizeContext';
import { useInView } from 'motion/react';
import { AnimVals } from '@/utils/animUtils';

import styles from './Title.module.scss';
import className from 'classnames/bind';
const cx = className.bind(styles);

type TitleProps = Omit<TitleFragment, '__typename'>;

export default function Title({ headline, sectionId }: TitleProps) {
  const headlineMarkup = headline ? getHighlightMarkup(headline) : null;

  // -------------------- Animation

  const { isDesktop } = useViewSize();

  const rootEl = useRef<HTMLDivElement>(null);
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });

  // -------------------- Render

  return (
    <section className={cx(["title"])} id={sectionId} data-section-id={sectionId} ref={rootEl}>
      <Container>
        <RevealWrapper isInView={isInView}>
          <HeadlineAnim
            tag="h2"
            text={headlineMarkup}
            className={cx('title-uc-xxxxl', 'headline')}
            isRevealEnabled={false}
            isInView={isInView}
          />
        </RevealWrapper>
      </Container>
    </section>
  );

}

Title.fragments = {
  entry: gql`
    fragment Title on FlexiblePageContentContentTitleLayout {
      headline
      sectionTitle
      sectionId
    }
  `,
};
